module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASUlEQVQ4y2P4jwQ+MAww7wADDNgPCh5EaHDwgAzm/4OEN3jChfn//wP8fwYFj///f6CzYKE0sDxQKAEzFMMg4Q1sLkbwBk9ZBwBKfYb/A0I7qgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xNlQxNzoxODoxMSswOTowMDtc+lcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00001_100x100.png
// module id = wQq4
// module chunks = 0